/* صفحة الفيدباكات — «عرض المزيد» بالكبسة + lightbox بالـ<dialog>.
   ------------------------------------------------------------------
   أربع ملاحظات حمّالة:

   1. الصفوف المخفيّة بتنحجب بـ`display: none` (`.sfb__row.is-hidden`).
      هذا هو اللي بيمنع تحميل صورها: `loading="lazy"` ما بيجيب صورة
      داخل عنصر محجوب. لو تحوّل الإخفاء لـ`visibility` أو `opacity`
      رح تنزل الـ128 لقطة دفعة وحدة على أول زيارة.

   2. الكشف **بالكبسة فقط** — لا IntersectionObserver. طلب المالكة
      الحرفي (2026-09-11): «لما ينزل لتحت يكبس مشاهدة المزيد»، نفس نمط
      صفحة المجموعة بثيم test. النسخة السابقة كانت تكشف مع التمرير
      وتخفي الزر؛ لا ترجّعها.

   3. الفتح بيصير بـ`showModal()` — الطبقة العليا الأصلية. هيك ما في
      تنافس `z-index` مع ودجت واتساب أو Judge.me، والخلفية بتصير inert،
      وEscape بيسكّر بدون أي كود منّا. ما تستبدلها بطبقة `position: fixed`.

   4. المشغّلات (`.srev__shot` و`.srev__verify`) روابط `<a href>` حقيقية
      للصورة الكاملة عن قصد: بدون جافاسكربت الزبونة بتفتح اللقطة عادي.
      لهيك كل مستمع هون بيعمل `preventDefault()` — لا تشيله. */
(function () {
  'use strict';

  function boot(root) {
    if (!root || root.dataset.sfbReady === '1') return;
    root.dataset.sfbReady = '1';

    var list = root.querySelector('[data-sfb-grid]');
    var dialog = root.querySelector('[data-sfb-lightbox]');
    if (!list) return;

    var items = [];
    function refreshItems() {
      items = Array.prototype.slice.call(list.querySelectorAll('[data-sfb-item]'));
    }
    refreshItems();
    if (!items.length) return;

    var batch = parseInt(root.getAttribute('data-sfb-batch'), 10);
    if (!batch || batch < 1) batch = 8;

    /* ── عرض المزيد ───────────────────────────────────────────────── */

    var more = root.querySelector('[data-sfb-more]');
    var moreBtn = root.querySelector('[data-sfb-more-btn]');
    var shownEl = root.querySelector('[data-sfb-shown]');
    var total = more ? parseInt(more.getAttribute('data-sfb-total'), 10) : 0;

    function hiddenRows() {
      return list.querySelectorAll('.sfb__row.is-hidden');
    }

    function syncCounter() {
      if (!more) return;
      var visible = list.querySelectorAll('.sfb__row:not(.is-hidden)').length;
      if (shownEl) shownEl.textContent = String(visible);
      if (total > 0) more.style.setProperty('--sfb-progress', ((visible * 100) / total).toFixed(1) + '%');
      if (!hiddenRows().length) more.hidden = true;
    }

    function reveal() {
      var hidden = hiddenRows();
      if (!hidden.length) return null;
      var n = Math.min(batch, hidden.length);
      for (var i = 0; i < n; i++) hidden[i].classList.remove('is-hidden');
      refreshItems();
      syncCounter();
      return hidden[0];
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var first = reveal();
        /* التركيز على أول صف جديد عشان القارئ الصوتي ولوحة المفاتيح
           يكملوا من مكان الكشف، مش من زر اختفى تحت. */
        var target = first ? first.querySelector('[data-sfb-item]') : null;
        if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      });
    }

    /* ── الـlightbox ──────────────────────────────────────────────── */

    if (!dialog || typeof dialog.showModal !== 'function') return;

    var lbImg = dialog.querySelector('[data-sfb-lb-img]');
    var lbCap = dialog.querySelector('[data-sfb-lb-cap]');
    var lbCur = dialog.querySelector('[data-sfb-lb-current]');
    var lbTot = dialog.querySelector('[data-sfb-lb-total]');
    var prevBtn = dialog.querySelector('[data-sfb-prev]');
    var nextBtn = dialog.querySelector('[data-sfb-next]');
    var closeBtn = dialog.querySelector('[data-sfb-close]');
    var index = 0;

    function render(i) {
      refreshItems();
      if (!items.length) return;
      index = (i + items.length) % items.length;
      var el = items[index];
      if (lbImg) {
        lbImg.src = el.getAttribute('data-full') || '';
        lbImg.alt = el.getAttribute('data-caption') || 'المحادثة الأصلية';
      }
      if (lbCap) lbCap.textContent = el.getAttribute('data-caption') || '';
      if (lbCur) lbCur.textContent = String(index + 1);
      if (lbTot) lbTot.textContent = String(items.length);
    }

    function open(i) {
      render(i);
      if (!dialog.open) dialog.showModal();
    }

    /* مستمع واحد على الكومة بدل 128 مستمع، وبيشتغل كمان على الصفوف اللي
       بتنكشف لاحقًا. المشغّلان: اللقطة نفسها ورابط «اقرئي المحادثة». */
    list.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var trigger = e.target.closest('[data-sfb-item], [data-sfb-open]');
      if (!trigger || !list.contains(trigger)) return;
      e.preventDefault();
      var row = trigger.closest('.sfb__row');
      var shot = row ? row.querySelector('[data-sfb-item]') : trigger;
      refreshItems();
      open(items.indexOf(shot));
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { render(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { render(index + 1); });
    if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });

    /* نقرة على الخلفية بتسكّر. `<dialog>` بيعطي حدث النقر على نفسه لما تكون
       النقرة خارج المحتوى، فالمقارنة بالمستطيل هي الفحص الصحيح. */
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      var out =
        e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
      if (out) dialog.close();
    });

    /* RTL: السهم الأيمن بيرجع للسابق، والأيسر بيروح للتالي. */
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); render(index - 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); render(index + 1); }
    });

    dialog.addEventListener('close', function () {
      if (lbImg) lbImg.removeAttribute('src');
      var back = items[index];
      /* العنصر ممكن يكون لسّه محجوبًا إذا تصفّحت الزبونة داخل الـlightbox
         أبعد من آخر دفعة مكشوفة — والتركيز عليه بيفشل بصمت. */
      if (back && back.offsetParent && typeof back.focus === 'function') back.focus();
    });
  }

  function bootAll() {
    var nodes = document.querySelectorAll('[data-sfb-root]');
    for (var i = 0; i < nodes.length; i++) boot(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll, { once: true });
  } else {
    bootAll();
  }

  /* محرّر الثيم بيعيد رسم القسم بدون إعادة تحميل الصفحة. */
  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target.querySelector ? e.target.querySelector('[data-sfb-root]') : null;
    if (node) boot(node);
  });
})();
